"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getStoreBadgeDataUris = void 0;
const icons_1 = require("../../email-templates/icons");
const locales_1 = require("../enums/locales");
const ENGLISH_STORE_BADGES = {
    appStore: icons_1.EMAIL_ICON_DATA_URI.appStoreBadge,
    googlePlay: icons_1.EMAIL_ICON_DATA_URI.googlePlayBadge,
};
const STORE_BADGES_BY_LOCALE = {
    [locales_1.Locales.EN]: ENGLISH_STORE_BADGES,
    [locales_1.Locales.ES]: ENGLISH_STORE_BADGES,
    [locales_1.Locales.FR]: { appStore: icons_1.EMAIL_ICON_DATA_URI.appStoreBadgeFr, googlePlay: icons_1.EMAIL_ICON_DATA_URI.googlePlayBadgeFr },
    [locales_1.Locales.DE]: { appStore: icons_1.EMAIL_ICON_DATA_URI.appStoreBadgeDe, googlePlay: icons_1.EMAIL_ICON_DATA_URI.googlePlayBadgeDe },
};
const getStoreBadgeDataUris = (locale) => STORE_BADGES_BY_LOCALE[locale] ?? ENGLISH_STORE_BADGES;
exports.getStoreBadgeDataUris = getStoreBadgeDataUris;
